import { PublishRulesCategoriesEnum } from '../enums/publishRulesCategoriesEnum';
import { IPublishRulesErpScheduledForm } from '../interfaces/IPublishRulesErpScheduledForm';
import { IPublishRulesTreeItem } from '../interfaces/IPublishRulesTreeItem';

export const getPublishRulesErpScheduledFormInitialValues: (
  treeItem: IPublishRulesTreeItem,
) => IPublishRulesErpScheduledForm = treeItem => {
  switch (treeItem.category) {
    case PublishRulesCategoriesEnum.PLANNED_PM_CHECKS:
      return {
        publicationDate: '15.12',
        additionalSettings: [],
      };
    case PublishRulesCategoriesEnum.PLANNED_PM_CHECKS_DP:
    case PublishRulesCategoriesEnum.PLANNED_PM_CHECKS_KZ:
    case PublishRulesCategoriesEnum.PLANNED_PM_CHECKS_VP:
    default:
      return { publicationDate: undefined, additionalSettings: [] };
  }
};
